import React from "react";
import ToolDescriptionCard from "./ToolDescriptionCard";
import SampleJobsPage from "../../assets/sample-jobs-page.png";
import { logEvent } from "helpers/analytics";
import { useHistory } from "react-router";

export default function SkilledWorkersJobsView() {
  const navigate = useHistory().push;

  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-14">
      <div className="w-full h-full">
        <img
          className="w-full h-[283px]  lg:h-full"
          src={SampleJobsPage}
          alt="Jobs Page"
        />
      </div>
      <div className="h-full">
        <ToolDescriptionCard
          title="JOBS"
          actionText="Find top jobs that match your skills"
          description="Gain access to exclusive job opportunities that match your talent, helping you grow your income and career."
          ctaText="Get started today"
          handleCTAClick={() => {
            logEvent("skilled_workers_landing_page_cta_click", {
              interest: "jobs",
            });

            navigate("/jobs");
          }}
        />
      </div>
    </div>
  );
}
